module.exports = __webpack_public_path__ + "img/a5-s25.1df367ca.jpg";